import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/siteData";

export const Footer = () => {
  const year = new Date().getFullYear();
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="footer" className="bg-neutral-950 text-neutral-300">
      <div className="h-[2px] w-full brand-gradient" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={COMPANY.icon} alt="Aqua Control Plumbing" className="h-16 w-auto object-contain" />
              <div>
                <div className="font-display font-extrabold text-lg text-white leading-none">Aqua Control</div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500">Plumbing & Hydronics</div>
              </div>
            </div>
            <p className="mt-6 text-neutral-400 max-w-sm leading-relaxed">{COMPANY.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-display font-bold mb-5">Explore</h4>
            <ul className="space-y-3 text-neutral-400">
              {[["Services", "#services"], ["Why Us", "#manifesto"], ["Reviews", "#reviews"], ["Service Areas", "#areas"], ["Get a Quote", "#quote"]].map(([l, h]) => (
                <li key={h}><button onClick={() => go(h)} className="hover:text-white transition-colors">{l}</button></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-white font-display font-bold mb-5">Contact</h4>
            <ul className="space-y-4 text-neutral-400">
              <li><a href={COMPANY.phoneHref} className="flex items-center gap-3 hover:text-white transition-colors"><Phone className="h-4 w-4 text-[#007AFF]" /> {COMPANY.phone}</a></li>
              <li><a href={COMPANY.emailHref} className="flex items-center gap-3 hover:text-white transition-colors break-all"><Mail className="h-4 w-4 text-[#FF3B30]" /> {COMPANY.email}</a></li>
              <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-1 text-neutral-500" /> <span>{COMPANY.addressLine1}<br />{COMPANY.addressLine2}<br />{COMPANY.country}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-neutral-500">
          <p>© {year} Aqua Control Plumbing & Hydronics. All rights reserved.</p>
          <p>Licensed & Insured • Serving the Greater Toronto Area</p>
        </div>
      </div>
    </footer>
  );
};
